module.exports = __webpack_public_path__ + "static/img/21e2d33d628cfdb8ce56057d2851809f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 1